export default function scrollerSponsorsDouble(widgetElName, widgetElOpts, sponsorsTime) {
  const widgetName = widgetElName;
  const widgetOpts = widgetElOpts;
  const $widget = $(`#${widgetName}`);

  const interval = setInterval(function () {
    if ($('body').hasClass('pageIsLoaded')) {
      setTimeout(() => {
        if (widgetElName === 'scroller-sponsors-rodeo') {
          updateSecondSponsorsStructure();
        } else if (widgetElName === 'scroller-sponsors-major') {
          updateThirdSponsorsStructure();
        } else {
          updateFirstSponsorsStructure();
        }

        const $pauseBtn = $(`#${widgetElName} .sponsor-controls-container button`);
        $pauseBtn.replaceWith('<span class="sponsor-playpause-btn"></span>');
        $(`#${widgetElName} .sponsor-playpause-btn`).on('click', function () {
          $(`#${widgetElName} .sponsorWidgetContainer `).toggleClass('sponsors-paused');
        });
      }, 2000);

      clearInterval(interval);
    }
  }, 800);

  function updateSecondSponsorsStructure() {
    $(`#${widgetElName} .sponsorWidgetContainer`).appendTo('.rodeo-scroller-container');
    $(`#${widgetElName} .sponsorCarouselImageContainer`).addClass('rodeo-container');
    $(`#${widgetElName} #sponsorArrowLeft`).appendTo('.rodeo-scroller-container');
    $(`#${widgetElName} #sponsorArrowRight`).appendTo('.rodeo-scroller-container');
    $(`#${widgetName}`).addClass('scroller-loaded');
    $(`#${widgetElName} a.no-link`).removeAttr('href').removeAttr('tabindex');
  }

  function updateThirdSponsorsStructure() {
    $(`#${widgetElName} .sponsorWidgetContainer`).appendTo('.major-scroller-container');
    $(`#${widgetElName} .sponsorCarouselImageContainer`).addClass('major-container');
    $(`#${widgetElName} #sponsorArrowLeft`).appendTo('.major-scroller-container');
    $(`#${widgetElName} #sponsorArrowRight`).appendTo('.major-scroller-container');
    $(`#${widgetName}`).addClass('scroller-loaded');
    $(`#${widgetElName} a.no-link`).removeAttr('href').removeAttr('tabindex');
  }

  function updateFirstSponsorsStructure() {
    const $majorSponsorTitle = $(`#${widgetElName} #majorSponsorTitleContainer`);
    const $majorSponsorContainer = $(`#${widgetElName} .majorSponsor`);
    const majorSponsorsTitle = $('#majorSponsorTitleContainer .homepageh1').text();

    if ($majorSponsorContainer.length && $majorSponsorTitle.length) {
      $majorSponsorTitle.wrapAll('<div class="major-sponsor-wrapper" id="major-sponsor-wrapper">');
      $majorSponsorContainer.appendTo($('#major-sponsor-wrapper'));
      $('#major-sponsor-wrapper').prependTo($(`#${widgetElName}`));

      $('#majorSponsorTitleContainer .homepageh1').replaceWith(
        `<h2 class="major-sponsor-title">${majorSponsorsTitle}</h2>`,
      );
    }

    const sponsorsTitleContent = $('#sponsorsTitleContainer .homepageh1').text();
    $('#sponsorsTitleContainer .homepageh1').replaceWith(
      `<h2 class="main-sponsors-title">${sponsorsTitleContent}</h2>`,
    );

    $('#sponsorsTitleContainer').insertBefore('.scroller-container');

    $(`#${widgetElName} .sponsorWidgetContainer `).appendTo('.scroller-container');
    $(`#${widgetElName} .sponsorCarouselImageContainer`).addClass('default-container');
    $(`#${widgetElName} #sponsorArrowLeft`).appendTo('.scroller-container');
    $(`#${widgetElName} #sponsorArrowRight`).appendTo('.scroller-container');

    $(`#${widgetName}`).addClass('scroller-loaded');
    $(`#${widgetElName} a.no-link`).removeAttr('href').removeAttr('tabindex');
  }

  return saffire.widgets.sponsors($widget, {
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    timePerSponsor: sponsorsTime,
    bw: false,
    rotate: true,
  });
}
